@if (deviceCount > 0) {
  <div class="fdx-u-display--none@x-small-only">
    <table class="fdx-c-table fdx-c-table--condensed">
      <thead class="fdx-c-table__thead fdx-c-table__thead--bordered">
        <tr>
          <th class="fdx-c-table__thead__th fdx-u-font-size--button-regular fdx-u-pl--0 fdx-u-cursor--pointer" (click)="sortDevices('deviceNickName', isAscending)" scope="col">{{ 'deviceManagement.device' | translate }}</th>
          <!-- <th *ngIf="isLocationColumnEnabled" class="fdx-c-table__thead__th fdx-u-font-size--button-regular fdx-u-pl--0 fdx-u-cursor--pointer" (click)="sortDevices('locationAccessed', isAscending)" scope="col">{{ 'deviceManagement.location' | translate }}</th> -->
          <th class="fdx-c-table__thead__th fdx-u-font-size--button-regular fdx-u-pl--0 fdx-u-cursor--pointer" (click)="sortDevices('lastLoginTime', isAscending)" scope="col">{{ 'trustedDevices.lastLogin' | translate }}</th>
          <th class="fdx-c-table__thead__th fdx-u-font-size--button-regular fdx-u-pl--0 fdx-u-cursor--pointer" scope="col"></th>
        </tr>
      </thead>
      <tbody class="fdx-c-table__tbody">
        @for (device of devices; track device; let i = $index) {
          <tr [attr.data-index]="i" class="device-table-font-weight fdx-c-table__tbody__tr fdx-c-table__tbody__tr--bordered">
            <td class="fdx-c-table__tbody__td fdx-u-font-size--default fdx-u-text--light fdx-u-pl--0" [attr.data-label]="'deviceManagement.device' | translate">
              <ciam-icon class="fdx-c-icon" aria-hidden="true" [key]="getDeviceIcon(device?.deviceNickName)"></ciam-icon>
              {{ device?.deviceNickName.split(' ')[0] }}, {{ device?.deviceType.split(': ')[1] }}
            </td>
            <!-- <td class="fdx-c-table__tbody__td fdx-u-font-size--default fdx-u-text--light fdx-u-pl--0" [attr.data-label]="'deviceManagement.location' | translate">{{ device?.locationAccessed }}</td> -->
            <td class="fdx-c-table__tbody__td fdx-u-font-size--default fdx-u-text--light fdx-u-pl--0" [attr.data-label]="'deviceManagement.lastSignIn' | translate">{{ device?.lastLoginTime | date:"MMM dd yy, h:mm a" }}</td>
            <td class="fdx-c-table__tbody__td--aside fdx-c-table__tbody__td fdx-u-align--right@medium fdx-c-table__tbody__td--hover">
              <button class="fdx-c-button fdx-c-button--condensed" (click)="onRemoveDevice(device?.deviceId)" aria-label="trash_button">
                <ciam-icon class="fdx-c-icon fdx-u-color--blue" aria-hidden="true" key="trashcan"></ciam-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (deviceCount > 0) {
  @for (device of devices; track device; let i = $index) {
    <div class="fdx-c-card fdx-c-card--is-expanded fdx-u-display--none@small" data-random-id="true">
      <div class="fdx-c-card__body" id="MY-BODY" role="region" aria-labelledby="MY-HEADER-ID">
        <h3 class="fdx-c-card__title fdx-u-fontweight--bold fdx-u-mb--1">{{ 'deviceManagement.device' | translate }}</h3>
        <div class="fdx-u-display--flex fdx-u-align--left fdx-u-mt--1 fdx-u-mb--6">
          <div class="fdx-u-mt--1">
            <ciam-icon
              class="fdx-c-icon fdx-u-align--center fdx-u-color--blue fdx-u-flex--center fdx-u-font-size--h2 fdx-u-mr--2"
            aria-hidden="true" [key]="getDeviceIcon(device?.deviceNickName)" color="#4d148c" id="deviceIcon"></ciam-icon>
          </div>
          <div class="fdx-u-display--flex" style="flex-direction: column;">
            <div><label for="deviceIcon" id="text-label" class="fdx-u-mt--1 fdx-u-font-size--h5">
            {{ device?.deviceNickName.split(' ')[0] }}</label></div>
            <div><label for="deviceIcon" id="device-label" class="fdx-u-mt--1 fdx-u-font-size--default">
            {{ device?.deviceType.split(': ')[1] }}</label></div>
          </div>
        </div>
        <!-- <h3 class="fdx-c-card__title fdx-u-fontweight--bold">{{ 'deviceManagement.location' | translate }}</h3> -->
        <!-- <p class="fdx-c-paragraph fdx-c-paragraph--regular fdx-u-mt--1 fdx-u-font-size--default fdx-u-mb--6">{{ device?.locationAccessed }}</p> -->
        <h3 class="fdx-c-card__title fdx-u-fontweight--bold">{{ 'trustedDevices.lastLogin' | translate }}</h3>
        <p class="fdx-c-paragraph fdx-c-paragraph--regular fdx-u-mt--1 fdx-u-font-size--default fdx-u-mb--6">{{ device?.lastLoginTime | date:"MMM dd yy, h:mm a" }}</p>
        <button class="fdx-c-button fdx-c-button--condensed" (click)="onRemoveDevice(device?.deviceId)" aria-label="trash_button">
          <ciam-icon class="fdx-c-icon fdx-u-font-size--h3 fdx-u-color--blue" aria-hidden="true" key="trashcan" color="#007ab7"></ciam-icon>
        </button>
      </div>
    </div>
  }
}
@if (deviceCount > 0) {
  <div class="fdx-u-align--center fdx-u-mt--9">
    <button class="fdx-c-button fdx-c-button--secondary-outline" (click)="onRemoveAllDevice()">
      {{'deviceManagement.removeAllDevices' | translate}}
    </button>
  </div>
}
@if (deviceCount === 0) {
  <wpro-no-trusted-device></wpro-no-trusted-device>
}
<wpro-remove-trusted-device [showDeletePopUp]='deleteDevice' (isRemoveDevice)="confirmRemoveDevice()"></wpro-remove-trusted-device>